<template>
  <section class="mt-3" v-if="userinfo">
    <div v-if="userinfo">

    <b-overlay :show="loading" rounded="sm">

       <h5 class="mt-3">{{ $t('FILTER.MESSAGE_STATUS.TITLE') }}</h5>
        <div class="mt-1">
          <b-form-tags
          input-id="tags-pills"
          v-model="messageStatus"
          :addButtonText="$t('ADD')"
          :duplicate-tag-text="$t('DUPLICATE_TAG_TEXT')"
          :invalid-tag-text="$t('INVALID_TAG_TEXT')"
          :limit-tags-text="$t('LIMIT_TAGS_TEXT')"
          tag-variant="secondary"
          addButtonVariant="secondary"
          :placeholder="$t('ADD')"
          separator=";"
        ></b-form-tags>
        </div>
      
      <hr class="p-0 m-0 mt-4 mb-2" />
      
      <b-button
        variant="primary"
        class="btn-fill mt-2"
        @click="saveBtn"
        >{{ $t("SAVE") }}</b-button
      >
       <b-button       
        v-if="changed"
        variant="secondary"
        class="btn-fill mt-2"
        @click="cancelBtn"
        >{{ $t("RESET") }}</b-button
      >

    </b-overlay>
    </div>
  </section>
</template>
<script>
export default {
  props: ["userinfo"],
  data() {
    return {
      messageStatus: [],
      loading: false
    };
  },
  methods: {
    cancelBtn(){
      this.messageStatus = this.userinfo.messageStatus;
    },
    saveBtn: function() {
      let self = this;
      self.loading = true;
      this.$http
        .post(
          this.user.hostname + "/user/edit/issue-status",
          {
            account_id: this.userinfo.id,
            status: this.messageStatus
          }
        )
        .then(function(result) {
          self.loading = false;
          self.$emit("updatedUser",result.data);
          self.$noty.info(self.$t("SAVED"));
        })
        .catch(function() {
          self.loading = false;
        });
    }    
  },
  computed: {
    changed(){
      return !this.arraysEqualUnordered(this.userinfo.messageStatus, this.messageStatus);
    }
  },
  mounted() {
    this.messageStatus = this.userinfo.messageStatus;
  },
};
</script>
<style></style>
